import { ArrowRight, Check, MapPin, Navigation, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export function SectionIntro({ eyebrow, title, text, align = 'left', inverse = false }) {
  return (
    <div className={`section-intro section-intro--${align} ${inverse ? 'section-intro--inverse' : ''}`}>
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      {text && <p>{text}</p>}
    </div>
  );
}

export function PageHero({ eyebrow, title, text, children, tone = 'light' }) {
  return (
    <section className={`page-hero page-hero--${tone}`}>
      <div className="page-hero__orb page-hero__orb--one" />
      <div className="page-hero__orb page-hero__orb--two" />
      <div className="container page-hero__inner">
        <div className="page-hero__copy">
          <span className="eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          <p>{text}</p>
          {children}
        </div>
        <div className="page-hero__signal" aria-hidden="true">
          <span><MapPin size={22} /></span>
          <i />
          <i />
          <span><Navigation size={22} /></span>
        </div>
      </div>
    </section>
  );
}

export function ServiceCard({ service }) {
  const Icon = service.icon;
  return (
    <article className={`service-card tone-${service.tone}`}>
      <div className="service-card__icon"><Icon aria-hidden="true" /></div>
      <span className="eyebrow">{service.eyebrow}</span>
      <h3>{service.title}</h3>
      <p>{service.description}</p>
      <Link className="text-link" to={service.to}>
        {service.cta} <ArrowRight size={17} aria-hidden="true" />
      </Link>
    </article>
  );
}

export function TrustCard({ item }) {
  const Icon = item.icon;
  return (
    <article className="trust-card">
      <span className="trust-card__icon"><Icon aria-hidden="true" /></span>
      <h3>{item.title}</h3>
      <p>{item.text}</p>
    </article>
  );
}

export function CTASection({ eyebrow = 'Ready when you are', title, text, primary, secondary }) {
  return (
    <section className="cta-section">
      <div className="cta-section__glow" />
      <div className="container cta-section__inner">
        <div>
          <span className="eyebrow">{eyebrow}</span>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <div className="button-row">
          {primary && <Link className="button button--light" to={primary.to}>{primary.label}</Link>}
          {secondary && <Link className="button button--ghost-light" to={secondary.to}>{secondary.label}</Link>}
        </div>
      </div>
    </section>
  );
}

export function Checklist({ items }) {
  return (
    <ul className="checklist">
      {items.map((item) => (
        <li key={item}><span><Check size={15} /></span>{item}</li>
      ))}
    </ul>
  );
}

export function PrototypeNotice({ children }) {
  return (
    <div className="prototype-notice" role="note">
      <ShieldCheck size={18} aria-hidden="true" />
      <p>{children}</p>
    </div>
  );
}
